import React from 'react';
import { BookmarkCheck, ArrowLeft } from 'lucide-react';
import { Reveal } from '../Reveal';
import type { ThemeConfig } from '../../types/forms';
import { getButtonStyles } from '../../lib/themeUtils';

interface SaveConfirmationProps {
  current: number;
  total: number;
  themeConfig: ThemeConfig;
  onResume: () => void;
  isPreview?: boolean;
}

export const SaveConfirmation: React.FC<SaveConfirmationProps> = ({
  current,
  total,
  themeConfig,
  onResume,
  isPreview,
}) => {
  return (
    <div
      className={`${isPreview ? 'h-full' : 'h-dvh'} relative flex flex-col items-center justify-center p-4 overflow-hidden`}
      style={{ backgroundColor: themeConfig.backgroundColor, fontFamily: `'${themeConfig.fontFamily}', sans-serif` }}
    >
      {/* Background blob */}
      <div className={`${isPreview ? 'absolute' : 'fixed'} inset-0 z-0 overflow-hidden pointer-events-none`}>
        <div className="absolute top-[-20%] left-1/2 -translate-x-1/2 w-[500px] h-[500px] bg-emerald-600/10 rounded-full blur-[100px] mix-blend-screen" />
      </div>

      <Reveal variant="zoom-in">
        <div className="relative z-10 liquid-glass rounded-3xl p-10 max-w-md text-center">
          <div className="w-20 h-20 mx-auto bg-emerald-500/20 rounded-full flex items-center justify-center mb-6">
            <BookmarkCheck className="w-10 h-10 text-emerald-400" />
          </div>

          <h1 className="text-2xl font-bold mb-2" style={{ color: themeConfig.textColor }}>
            Progresso salvo!
          </h1>

          <p className="mb-2" style={{ color: themeConfig.textColor, opacity: 0.6 }}>
            Você respondeu {current} de {total} perguntas.
          </p>

          <p className="text-sm mb-8" style={{ color: themeConfig.textColor, opacity: 0.5 }}>
            Quando voltar a este formulário no mesmo navegador, poderá continuar de onde parou.
          </p>

          <button
            type="button"
            onClick={onResume}
            style={getButtonStyles(themeConfig)}
            className="inline-flex items-center gap-2 font-medium transition-all duration-200"
          >
            <ArrowLeft className="w-4 h-4" />
            Voltar ao formulário
          </button>
        </div>
      </Reveal>
    </div>
  );
};
